"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/opt/build/repo/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _httpResponseErrorCod, _apiErrorCodes;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildRequestError = exports.APIResponseError = exports.UnknownHTTPResponseError = exports.isHTTPResponseError = exports.RequestTimeoutError = exports.isNotionClientError = exports.ClientErrorCode = exports.APIErrorCode = void 0;

var utils_1 = require("./utils");
/**
 * Error codes returned in responses from the API.
 */


var APIErrorCode;

(function (APIErrorCode) {
  APIErrorCode["Unauthorized"] = "unauthorized";
  APIErrorCode["RestrictedResource"] = "restricted_resource";
  APIErrorCode["ObjectNotFound"] = "object_not_found";
  APIErrorCode["RateLimited"] = "rate_limited";
  APIErrorCode["InvalidJSON"] = "invalid_json";
  APIErrorCode["InvalidRequestURL"] = "invalid_request_url";
  APIErrorCode["InvalidRequest"] = "invalid_request";
  APIErrorCode["ValidationError"] = "validation_error";
  APIErrorCode["ConflictError"] = "conflict_error";
  APIErrorCode["InternalServerError"] = "internal_server_error";
  APIErrorCode["ServiceUnavailable"] = "service_unavailable";
})(APIErrorCode = exports.APIErrorCode || (exports.APIErrorCode = {}));
/**
 * Error codes generated for client errors.
 */


var ClientErrorCode;

(function (ClientErrorCode) {
  ClientErrorCode["RequestTimeout"] = "notionhq_client_request_timeout";
  ClientErrorCode["ResponseError"] = "notionhq_client_response_error";
})(ClientErrorCode = exports.ClientErrorCode || (exports.ClientErrorCode = {}));
/**
 * Base error type.
 */


var NotionClientErrorBase = /*#__PURE__*/function (_Error) {
  _inherits(NotionClientErrorBase, _Error);

  var _super = _createSuper(NotionClientErrorBase);

  function NotionClientErrorBase() {
    _classCallCheck(this, NotionClientErrorBase);

    return _super.apply(this, arguments);
  }

  return NotionClientErrorBase;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * @param error any value, usually a caught error.
 * @returns `true` if error is a `NotionClientError`.
 */


function isNotionClientError(error) {
  return (0, utils_1.isObject)(error) && error instanceof NotionClientErrorBase;
}

exports.isNotionClientError = isNotionClientError;
/**
 * Narrows down the types of a NotionClientError.
 * @param error any value, usually a caught error.
 * @param codes an object mapping from possible error codes to `true`
 * @returns `true` if error is a `NotionClientError` with a code in `codes`.
 */

function isNotionClientErrorWithCode(error, codes) {
  return isNotionClientError(error) && error.code in codes;
}
/**
 * Error thrown by the client if a request times out.
 */


var RequestTimeoutError = /*#__PURE__*/function (_NotionClientErrorBas) {
  _inherits(RequestTimeoutError, _NotionClientErrorBas);

  var _super2 = _createSuper(RequestTimeoutError);

  function RequestTimeoutError() {
    var _this;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Request to Notion API has timed out";

    _classCallCheck(this, RequestTimeoutError);

    _this = _super2.call(this, message);
    _this.code = ClientErrorCode.RequestTimeout;
    _this.name = "RequestTimeoutError";
    return _this;
  }

  _createClass(RequestTimeoutError, null, [{
    key: "isRequestTimeoutError",
    value: function isRequestTimeoutError(error) {
      return isNotionClientErrorWithCode(error, _defineProperty({}, ClientErrorCode.RequestTimeout, true));
    }
  }, {
    key: "rejectAfterTimeout",
    value: function rejectAfterTimeout(promise, timeoutMS) {
      return new Promise(function (resolve, reject) {
        var timeoutId = setTimeout(function () {
          reject(new RequestTimeoutError());
        }, timeoutMS);
        promise.then(resolve).catch(reject).then(function () {
          return clearTimeout(timeoutId);
        });
      });
    }
  }]);

  return RequestTimeoutError;
}(NotionClientErrorBase);

exports.RequestTimeoutError = RequestTimeoutError;

var HTTPResponseError = /*#__PURE__*/function (_NotionClientErrorBas2) {
  _inherits(HTTPResponseError, _NotionClientErrorBas2);

  var _super3 = _createSuper(HTTPResponseError);

  function HTTPResponseError(args) {
    var _this2;

    _classCallCheck(this, HTTPResponseError);

    _this2 = _super3.call(this, args.message);
    _this2.name = "HTTPResponseError";
    var code = args.code,
        status = args.status,
        headers = args.headers,
        rawBodyText = args.rawBodyText;
    _this2.code = code;
    _this2.status = status;
    _this2.headers = headers;
    _this2.body = rawBodyText;
    return _this2;
  }

  return HTTPResponseError;
}(NotionClientErrorBase);

var httpResponseErrorCodes = (_httpResponseErrorCod = {}, _defineProperty(_httpResponseErrorCod, ClientErrorCode.ResponseError, true), _defineProperty(_httpResponseErrorCod, APIErrorCode.Unauthorized, true), _defineProperty(_httpResponseErrorCod, APIErrorCode.RestrictedResource, true), _defineProperty(_httpResponseErrorCod, APIErrorCode.ObjectNotFound, true), _defineProperty(_httpResponseErrorCod, APIErrorCode.RateLimited, true), _defineProperty(_httpResponseErrorCod, APIErrorCode.InvalidJSON, true), _defineProperty(_httpResponseErrorCod, APIErrorCode.InvalidRequestURL, true), _defineProperty(_httpResponseErrorCod, APIErrorCode.InvalidRequest, true), _defineProperty(_httpResponseErrorCod, APIErrorCode.ValidationError, true), _defineProperty(_httpResponseErrorCod, APIErrorCode.ConflictError, true), _defineProperty(_httpResponseErrorCod, APIErrorCode.InternalServerError, true), _defineProperty(_httpResponseErrorCod, APIErrorCode.ServiceUnavailable, true), _httpResponseErrorCod);

function isHTTPResponseError(error) {
  if (!isNotionClientErrorWithCode(error, httpResponseErrorCodes)) {
    return false;
  }

  return true;
}

exports.isHTTPResponseError = isHTTPResponseError;
/**
 * Error thrown if an API call responds with an unknown error code, or does not respond with
 * a property-formatted error.
 */

var UnknownHTTPResponseError = /*#__PURE__*/function (_HTTPResponseError) {
  _inherits(UnknownHTTPResponseError, _HTTPResponseError);

  var _super4 = _createSuper(UnknownHTTPResponseError);

  function UnknownHTTPResponseError(args) {
    var _this3;

    _classCallCheck(this, UnknownHTTPResponseError);

    var _a;

    _this3 = _super4.call(this, _objectSpread(_objectSpread({}, args), {}, {
      code: ClientErrorCode.ResponseError,
      message: (_a = args.message) !== null && _a !== void 0 ? _a : "Request to Notion API failed with status: ".concat(args.status)
    }));
    _this3.name = "UnknownHTTPResponseError";
    return _this3;
  }

  _createClass(UnknownHTTPResponseError, null, [{
    key: "isUnknownHTTPResponseError",
    value: function isUnknownHTTPResponseError(error) {
      return isNotionClientErrorWithCode(error, _defineProperty({}, ClientErrorCode.ResponseError, true));
    }
  }]);

  return UnknownHTTPResponseError;
}(HTTPResponseError);

exports.UnknownHTTPResponseError = UnknownHTTPResponseError;
var apiErrorCodes = (_apiErrorCodes = {}, _defineProperty(_apiErrorCodes, APIErrorCode.Unauthorized, true), _defineProperty(_apiErrorCodes, APIErrorCode.RestrictedResource, true), _defineProperty(_apiErrorCodes, APIErrorCode.ObjectNotFound, true), _defineProperty(_apiErrorCodes, APIErrorCode.RateLimited, true), _defineProperty(_apiErrorCodes, APIErrorCode.InvalidJSON, true), _defineProperty(_apiErrorCodes, APIErrorCode.InvalidRequestURL, true), _defineProperty(_apiErrorCodes, APIErrorCode.InvalidRequest, true), _defineProperty(_apiErrorCodes, APIErrorCode.ValidationError, true), _defineProperty(_apiErrorCodes, APIErrorCode.ConflictError, true), _defineProperty(_apiErrorCodes, APIErrorCode.InternalServerError, true), _defineProperty(_apiErrorCodes, APIErrorCode.ServiceUnavailable, true), _apiErrorCodes);
/**
 * A response from the API indicating a problem.
 * Use the `code` property to handle various kinds of errors. All its possible values are in `APIErrorCode`.
 */

var APIResponseError = /*#__PURE__*/function (_HTTPResponseError2) {
  _inherits(APIResponseError, _HTTPResponseError2);

  var _super5 = _createSuper(APIResponseError);

  function APIResponseError() {
    var _this4;

    _classCallCheck(this, APIResponseError);

    _this4 = _super5.apply(this, arguments);
    _this4.name = "APIResponseError";
    return _this4;
  }

  _createClass(APIResponseError, null, [{
    key: "isAPIResponseError",
    value: function isAPIResponseError(error) {
      return isNotionClientErrorWithCode(error, apiErrorCodes);
    }
  }]);

  return APIResponseError;
}(HTTPResponseError);

exports.APIResponseError = APIResponseError;

function buildRequestError(response, bodyText) {
  var apiErrorResponseBody = parseAPIErrorResponseBody(bodyText);

  if (apiErrorResponseBody !== undefined) {
    return new APIResponseError({
      code: apiErrorResponseBody.code,
      message: apiErrorResponseBody.message,
      headers: response.headers,
      status: response.status,
      rawBodyText: bodyText
    });
  }

  return new UnknownHTTPResponseError({
    message: undefined,
    headers: response.headers,
    status: response.status,
    rawBodyText: bodyText
  });
}

exports.buildRequestError = buildRequestError;

function parseAPIErrorResponseBody(body) {
  if (typeof body !== "string") {
    return;
  }

  var parsed;

  try {
    parsed = JSON.parse(body);
  } catch (parseError) {
    return;
  }

  if (!(0, utils_1.isObject)(parsed) || typeof parsed["message"] !== "string" || !isAPIErrorCode(parsed["code"])) {
    return;
  }

  return _objectSpread(_objectSpread({}, parsed), {}, {
    code: parsed["code"],
    message: parsed["message"]
  });
}

function isAPIErrorCode(code) {
  return typeof code === "string" && code in apiErrorCodes;
}